// extracted by mini-css-extract-plugin
module.exports = {"video":"SectionVideo-module--video--NDdLl","content":"SectionVideo-module--content--1yns8","wrapper":"SectionVideo-module--wrapper--2haYY"};